module.exports = __webpack_public_path__ + "img/发货ico.622e3375.png";